import { DeviceChannelConfiguration } from '@core/models';
import { PvForecastEmeterChannel } from '../devices/components/pv-forecast-form/pv-forecast-form';

// Backend category name for energy meters.
const EMETER_CATEGORY = 'Energy Meter';

// The channels the PV forecast dialog offers as the forecast's energy meter, built as the device
// page's PV card builds them: a DLMS device is itself an energy meter at index 0, and every
// configured energy meter channel counts as another.
export function pvEmeterChannels(
  configuration: DeviceChannelConfiguration | undefined,
  protocol: string | undefined,
): PvForecastEmeterChannel[] {
  const configured = (configuration?.channels ?? [])
    .filter(channel => channel.category === EMETER_CATEGORY)
    .map(channel => ({ channelNumber: channel.channelNumber, description: channel.description }));

  if (protocol === 'DLMS') {
    return [{ channelNumber: 0, description: '', isDeviceMeter: true }, ...configured];
  }
  return configured;
}
